import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import ContactInteractionsView from './ContactInteractionsView.vue';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent', 'contact_manage'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/interactions'),
      name: 'contact_interactions',
      meta: commonMeta,
      component: ContactInteractionsView,
      props: () => ({ contactId: 0 }),
    },
    {
      path: frontendURL('accounts/:accountId/interactions/:contactId'),
      name: 'contact_interactions_view',
      meta: commonMeta,
      component: ContactInteractionsView,
      props: route => ({ contactId: route.params.contactId }),
    },
  ],
};
